import { useEffect, useRef, useState } from "react";
import { Button, Modal, Row } from "react-bootstrap";
import { ErrorMessage, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { MyTextInput } from "../ui/controls/MyTextInput";
import { MySelect } from "../ui/controls/MySelect";
import { useSelector, useDispatch } from 'react-redux';
import { WithContext as ReactTags } from 'react-tag-input';
import '../../assets/css/reactTags.css'
import { MyDatePicker } from "../ui/controls/MyDatePicker";
import { MyTextArea2 } from "../ui/controls/MyTextArea2";
import { onlyIntegers, onlyIntegersDecimals } from "../../helpers/numericFields";
import { MyCheckBox } from "../ui/controls/MyCheckBox";
import { editGroupFile as editGroupFile2 } from "../../store/slices/groupFiles/thunks";
import moment from 'moment'
import { MyCheckBox2 } from "../ui/controls/MyCheckBox2";
import { MyTextInput66 } from "../ui/controls/MyTextInput66";
import { MyTextLabel66 } from "../ui/controls/MyTextLabel66";

const KeyCodes = {
  comma: 188,
  enter: 13
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];

export const EditGroupFile = ({ groupFile, isOpen, setIsOpen }) => {
  const dispatch = useDispatch();
  const { categoriesList, } = useSelector((state) => state.files);
  const { additionalList } = useSelector((state) => state.groupFiles);
  const { customersList } = useSelector((state) => state.general);
  const [tags, setTags] = useState([]);
  const [daysNights, setDaysNights] = useState({ days: 0, nights: 0 });
  const [additionals, setAdditionals] = useState({});
  const [tag, setTag] = useState({});

  const handleDelete = i => {
    setTags(tags.filter((tag, index) => index !== i));
  };

  const handleAddition = tag => {
    setTags([...tags, tag]);
  };

  const handleDrag = (tag, currPos, newPos) => {
    const newTags = tags.slice();

    newTags.splice(currPos, 1);
    newTags.splice(newPos, 0, tag);

    // re-render
    setTags(newTags);
  };

  const handleTagClick = index => {

  };

  const handleAdditionButton = tag => {
    if (tag.id) {      
      const item = tags.find(x => x.id === tag.id);      
      if (!item) {
        setTag({})
        handleAddition(tag)
      }
    }
  };


  const searchInput = useRef(null);

  useEffect(() => {
    if (groupFile.tags) {
      setTags(groupFile.tags.split(",").map(item => ({ "id": item, "text": item })));
    }
  }, [groupFile.tags, isOpen])

  useEffect(() => {
    const date1 = new moment(groupFile.startDate, "DD-MM-YYYY")
    const date2 = new moment(groupFile.endDate, "DD-MM-YYYY")
    setDaysNights({ days: date2.diff(date1, 'days') + 1, nights: date2.diff(date1, 'days') })
  }, [groupFile.startDate, isOpen])

  useEffect(() => {
    if (groupFile.additionals) {
      const newAdditionals = {};
      for (let i = 0; i < groupFile.additionals.length; i++) {
        newAdditionals[groupFile.additionals[i].id] = true;
      }
      setAdditionals(newAdditionals)
    }
  }, [groupFile.additionals, isOpen])



  return (
    <>
      <Modal
        size="xl"
        show={isOpen}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header>
          <Modal.Title >
            Editar Grupo
          </Modal.Title>
          <Button
            onClick={() => setIsOpen(false)}
            className="btn-close"
            variant=""
          >
            x
          </Button>
        </Modal.Header>

        <Formik
          initialValues={{
            idCustomer: { "value": groupFile.idCustomer, "label": groupFile.customer },
            name: groupFile.name,
            idCategory: { "value": groupFile.idCategory, "label": groupFile.category },
            lodging: groupFile.lodging,
            startEndDate: [groupFile.startDate, groupFile.endDate],
            paydayLimit: groupFile.paydayLimit,
            passengers: groupFile.passengers,
            rooms: groupFile.rooms,
            notes: groupFile.notes,
            peopleQuantity: groupFile.peopleQuantity,
            additionalPersonPrice: groupFile.additionalPersonPrice,
            weddingPassPrice: groupFile.weddingPassPrice,
            suplementPrice: groupFile.suplementPrice,
            isOpen: groupFile.isOpen === 1 ? true : false,
            isVisible: groupFile.isVisible === 1 ? true : false,
            isPaydayLimitLockEnabled: groupFile.isPaydayLimitLockEnabled === 1 ? true : false,
            isSeatingPlanLockEnabled: groupFile.isSeatingPlanLockEnabled === 1 ? true : false,
            isCourtshipLineLockEnabled: groupFile.isCourtshipLineLockEnabled === 1 ? true : false,
            tags: '',
            ...additionals
          }}
          onSubmit={(({ idCustomer, name, idCategory, lodging, startEndDate, paydayLimit, passengers,
            rooms, peopleQuantity, additionalPersonPrice, 
            weddingPassPrice, suplementPrice, notes, isOpen, isVisible, isPaydayLimitLockEnabled, isSeatingPlanLockEnabled,
            isCourtshipLineLockEnabled, ...additional },
            { resetForm, setErrors }) => {

            if (!idCustomer) {
              return setErrors({ "idCustomer": "Requerido" })
            }
            if (!idCategory) {
              return setErrors({ "idCategory": "Requerido" })
            }
            if (tags === "" || tags.length === 0) {
              return setErrors({ "tags": "Requerido" })
            }

            let startDate;
            if (startEndDate[0].year) {
              startDate = startEndDate[0].year + "-" + (startEndDate[0].monthIndex + 1) + "-" + startEndDate[0].day
            } else {
              const temp = startEndDate[0].split("-")
              startDate = temp[2] + "-" + temp[1] + "-" + temp[0]
            }
            let endDate;
            if (startEndDate[1].year) {
              endDate = startEndDate[1].year + "-" + (startEndDate[1].monthIndex + 1) + "-" + startEndDate[1].day
            } else {
              const temp = startEndDate[1].split("-")
              endDate = temp[2] + "-" + temp[1] + "-" + temp[0]
            }

            let paydayLimit2;
            
            if (paydayLimit) {
              if (paydayLimit.year) {
                paydayLimit2 = paydayLimit.year + "-" + (paydayLimit.monthIndex + 1) + "-" + paydayLimit.day
              } else {
                const temp = paydayLimit.split("-")
                paydayLimit2 = temp[2] + "-" + temp[1] + "-" + temp[0]
              }
            }

            if (!startEndDate || startEndDate.length !== 2) {
              return setErrors({ "startEndDate": "Requerido" })
            }

            const success = () => {
              resetForm();
              setIsOpen(false);
              setTags([])
            }

            const newAdditional = Object.keys(additional).map(item => {
              if (additional[item]) return item
            })
            const newAdditionalList = newAdditional.filter(x => x)

            dispatch(editGroupFile2(groupFile.id, idCustomer.value, idCategory.value, name, tags.map(item => item.text).join(", "),
              startDate, endDate, paydayLimit2, lodging, passengers, rooms, newAdditionalList,
              peopleQuantity, additionalPersonPrice, weddingPassPrice, suplementPrice, notes, isOpen, isVisible, isPaydayLimitLockEnabled, isSeatingPlanLockEnabled, isCourtshipLineLockEnabled, success));

          })}
          validationSchema={
            Yup.object({
              name: Yup.string()
                .required("Requerido"),
            })
          }
        >

          {
            ({ setFieldValue }) => (
              <Form>
                <Modal.Body>
                  <Row>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MySelect label='Cliente:*' name="idCustomer" options={customersList} mode='horizontal'
                          singleSelect="true"
                          onChange={e => {
                            setFieldValue("idCustomer", e);
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MyTextInput label='Nombre:*' name='name' mode='horizontal' />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MySelect label='Categoria:*' name="idCategory" options={categoriesList} mode='horizontal'
                          singleSelect="true"
                          onChange={e => {
                            setFieldValue("idCategory", e);
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <div className="mb-3 row">
                          <label className='col-form-label col-4' htmlFor="destinations" >Destinos:*</label>
                          <div className="col-7">
                            <ReactTags
                              tags={tags}
                              placeholder=""
                              delimiters={delimiters}
                              handleDelete={handleDelete}
                              handleAddition={handleAddition}
                              handleDrag={handleDrag}
                              handleTagClick={handleTagClick}
                              handleInputChange={(e) => setTag({ id: e, text: e })}
                              inputFieldPosition="top"
                              autocomplete
                            />
                            <ErrorMessage name="tags" component="span" style={{ color: "red" }} />
                          </div>
                          <div className="col-1">
                            <Button onClick={() => handleAdditionButton(tag)}>+</Button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MyTextInput label='Alojamiento(s):' name='lodging' mode='horizontal' />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MyDatePicker
                          label='Fechas Viaje:*' name="startEndDate" mode='horizontal'
                          className="form-control fc-datepicker"
                          singleSelect="true"
                          placeholder="dd/mm/aaaa ~ dd/mm/aaaa"
                          range
                          onChange={e => {
                            setFieldValue("startEndDate", e);
                            if (!e || e.length === 2) {
                              const date1 = new moment(e[0].day + "-" + (e[0].monthIndex + 1) + "-" + e[0].year, "DD-MM-YYYY")
                              const date2 = new moment(e[1].day + "-" + (e[1].monthIndex + 1) + "-" + e[1].year, "DD-MM-YYYY")
                              setDaysNights({ days: date2.diff(date1, 'days') + 1, nights: date2.diff(date1, 'days') })
                            }
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MyDatePicker
                          label='Fecha limite de pago:' name="paydayLimit" mode='horizontal'
                          className="form-control fc-datepicker"
                          singleSelect="true"
                          placeholder="dd/mm/aaaa"
                          onChange={e => {
                            setFieldValue("paydayLimit", e);
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MyTextInput label='Huespedes:' name='passengers' mode='horizontal'
                          onChange={(e) => {
                            if (!onlyIntegers(e)) {
                              return
                            }
                            setFieldValue("passengers", e.target.value);
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-12">
                      <div className=" row mb-4">
                        <MyTextInput66 label='Habitaciones:' name='rooms' mode='horizontal'
                          onChange={(e) => {
                            if (!onlyIntegers(e)) {
                              return
                            }
                            setFieldValue("rooms", e.target.value);
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-12">
                      <div className=" row mb-4">
                        <MyTextLabel66 label='Noches:' mode='horizontal' value={daysNights.nights} />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-12">
                      <div className=" row mb-4">
                        <MyTextLabel66 label='Dias:' mode='horizontal' value={daysNights.days} />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-12">
                      <div className=" row mb-4">
                        <MyTextInput66 label='Personas en el paquete:' name='peopleQuantity' mode='horizontal'
                          onChange={(e) => {
                            if (!onlyIntegers(e)) {
                              return
                            }
                            setFieldValue("peopleQuantity", e.target.value);
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-12">
                      <div className=" row mb-4">
                        <MyTextInput66 label='Costo persona extra:' name='additionalPersonPrice' mode='horizontal'
                          onChange={(e) => {
                            if (!onlyIntegersDecimals(e)) {
                              return
                            }
                            setFieldValue("additionalPersonPrice", e.target.value);
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-12">
                      <div className=" row mb-4">
                        <MyTextInput66 label='Costo wedding pass:' name='weddingPassPrice' mode='horizontal'
                          onChange={(e) => {
                            if (!onlyIntegersDecimals(e)) {
                              return
                            }
                            setFieldValue("weddingPassPrice", e.target.value);
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-12">
                      <div className=" row mb-4">
                        <MyTextInput66 label='Costo suplemento:' name='suplementPrice' mode='horizontal'
                          onChange={(e) => {
                            if (!onlyIntegersDecimals(e)) {
                              return
                            }
                            setFieldValue("suplementPrice", e.target.value);
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-12" >
                      <div className=" row mb-4">
                        <MyCheckBox2 label="Abierto:" name="isOpen" mode='horizontal' style={{ fontSize: 20, marginTop: 8 }} />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-12" >
                      <div className=" row mb-4">
                        <MyCheckBox2 label="Visible:" name="isVisible" mode='horizontal' style={{ fontSize: 20, marginTop: 8 }} />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12" >
                      <div className=" row mb-4">
                        <MyCheckBox2 label="Candado de fecha limite:" name="isPaydayLimitLockEnabled" mode='horizontal' style={{ fontSize: 20, marginTop: 8 }} />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12" >
                      <div className=" row mb-4">
                        <MyCheckBox2 label="Candado de mesas:" name="isSeatingPlanLockEnabled" mode='horizontal' style={{ fontSize: 20, marginTop: 8 }} />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12" >
                      <div className=" row mb-4">
                        <MyCheckBox2 label="Candado de cortejo:" name="isCourtshipLineLockEnabled" mode='horizontal' style={{ fontSize: 20, marginTop: 8 }} />
                      </div>
                    </div>
                    {
                      additionalList.map(item => (
                        <div className="col-lg-3 col-md-12" key={item.id}>
                          <div className=" row mb-4">
                            <MyCheckBox label={`${item.name}`} name={item.id} mode='horizontal' />
                          </div>
                        </div>
                      ))
                    }
                    <div className="col-lg-12 col-md-12">
                      <div className=" row mb-4">
                        <MyTextArea2 label='Notas:' name='notes' mode='horizontal' rows={4} />
                      </div>
                    </div>
                  </Row>
                  <div style={{ fontSize: 13 }}>* Dato obligatorio</div>
                </Modal.Body>

                <Modal.Footer>
                  <Button variant="primary" type="submit">
                    Guardar Informacion
                  </Button>
                </Modal.Footer>
              </Form>
            )
          }
        </Formik>


      </Modal>
    </>
  );
}
